import types from './types';

const initialState = {
  selectedSegments: [],
  createdRouteId: null,
};

export default function routeCreation(state = initialState, action) {
  switch (action.type) {
    case types.SELECT_SEGMENT:
      return {
        ...state,
        selectedSegments: [...state.selectedSegments, action.payload.id],
      };

    case types.DESELECT_SEGMENT:
      return {
        ...state,
        selectedSegments: state.selectedSegments.filter(id => id !== action.payload.id),
      };

    case types.SET_CREATED_ROUTE_ID:
      return {
        ...state,
        createdRouteId: action.payload.id,
      };

    case types.CLEAR_CREATE_ROUTE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/ducks/routeCreation/reducers.js